import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  bingmapKey: PropTypes.string,
  location: PropTypes.object,
  mapSize: PropTypes.object,
}

const defaultProps = {
  mapSize: {
    width: '300',
    height: '400',
  },
}

const BingStaticMap = ({ bingmapKey, location, mapSize }) => {
  const { width, height } = mapSize
  const mapUrl = `https://dev.virtualearth.net/REST/V1/Imagery/Map/CanvasGray/${location.latitude}%2C${location.longitude}/?zoomLevel=0&mapSize=${width},${height}&format=png&pushpin=${location.latitude},${location.longitude};64;&key=${bingmapKey}`
  return <img src={mapUrl} alt="morrisons store" data-cy="store-location-map" />
}

BingStaticMap.prototypes = propTypes
BingStaticMap.defaultProps = defaultProps

export default BingStaticMap
